var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 40",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.47,16.8a2.3,2.3,0,0,0-1.73.23,8.69,8.69,0,0,1-7.48,0,2.3,2.3,0,0,0-1.73-.23C5.35,18.24,2,21.59,2,25.33v2.55A2.19,2.19,0,0,0,4.24,30H27.76A2.19,2.19,0,0,0,30,27.88V25.33C30,21.59,26.65,18.24,21.47,16.8ZM28,27.88s-.09.12-.24.12H4.24c-.16,0-.24-.09-.24-.12V25.33c0-2.82,2.77-5.41,7.07-6.6h0a.44.44,0,0,1,.2.06,10.73,10.73,0,0,0,9.4,0,.35.35,0,0,1,.23-.05h0c4.29,1.19,7.06,3.78,7.06,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9a7,7,0,1,0,7-7A7,7,0,0,0,9,9ZM21,9a5,5,0,1,1-5-5A5,5,0,0,1,21,9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.b6b717fc8773d5d4f3f7915098d8f028.svg";
export { ForwardRef as ReactComponent };